// GoogleScolarIcon.vue
<template>
  <img src="./../assets/icons/faces-icon.webp" alt="arxiv"/>
</template>
  
  <script>
  export default {
    name: "arxiv-icon",
  };
  </script>
  
  <style>
   svg { 
    width: 30px !important;
    height: 30px !important;
  }
  </style>